<div *ngIf="isNewVersion; else version1">
  <div class="dashboard_title">
    <h3>Olá, {{ getUserName() }}.</h3>
  </div>

  <app-metabase-frame 
    *ngIf="metabaseAttribute" 
    [attribute]="metabaseAttribute">
  </app-metabase-frame>

  <div *ngIf="startMenuAttrs?.length">
    <app-dynamic *ngFor="let attr of startMenuAttrs; trackBy: trackByAttr"
      [attribute]="attr"
      [envOptions]="envOptions">
    </app-dynamic>
  </div>

  <div *ngIf="isCustomer && customerLimit > 0" class="dashboard__status">
    <div class="card">
      <p class="card-title">{{ "Limite atual" }} (R$ {{ customerLimitFormated }})</p>
      <circle-progress [percent]="customerUsagePercent" [radius]="100" [outerStrokeWidth]="16" [innerStrokeWidth]="8"
        [outerStrokeColor]="blue" [innerStrokeColor]="blue" [animation]="true" [responsive]="true"
        [showSubtitle]="false" [titleFontSize]="40" [unitsFontSize]="30" [animationDuration]="300"></circle-progress>
      <p class="card-title">{{ "Limite utilizado" }} (R$ {{ customerAmmountFormated }})</p>
    </div>
    <div class="card">
      <p class="card-title">{{ "Limite potencial" }} (R$ {{ customerPotentialLimitFormated }})</p>
      <a (click)="togglePopup()" class="details-link">mais detalhes sobre seu limite</a>
      <div class="details-popup" *ngIf="showPopup">
        <table>
          <tr>
            <th>Período (em dias)</th>
            <th>Valor (em reais)</th>
          </tr>
          <tr *ngFor="let item of agendaCerc.agenda">
            <td>{{ item.period }}</td>
            <td>{{ item.totalValorLivre | currency:'BRL' }}</td>
          </tr>
          <tr class="total-row">
            <td>Total</td>
            <td>{{ agendaCerc.totalValorLivre | currency:'BRL' }}</td>
          </tr>
        </table>
      </div>
      <circle-progress [percent]="customerPotentialUsagePercent" [radius]="100" [outerStrokeWidth]="16" [innerStrokeWidth]="8"
        [outerStrokeColor]="blue" [innerStrokeColor]="blue" [animation]="true" [responsive]="true"
        [showSubtitle]="false" [titleFontSize]="40" [unitsFontSize]="30" [animationDuration]="300"></circle-progress>
    </div>
  </div>

  <div *ngIf="isSeller && sellerLimit > 0" class="dashboard__status">
    <div class="card">
      <p class="card-title">{{ "Limite atual" }} (R$ {{ sellerLimitFormated }})</p>
      <circle-progress [percent]="sellerUsagePercent" [radius]="100" [outerStrokeWidth]="16" [innerStrokeWidth]="8"
        [outerStrokeColor]="blue" [innerStrokeColor]="blue" [animation]="true" [responsive]="true"
        [showSubtitle]="false" [titleFontSize]="40" [unitsFontSize]="30" [animationDuration]="300"></circle-progress>
      <p class="card-title">{{ "Limite utilizado" }} (R$ {{ sellsAmmountFormated }})</p>
    </div>
  </div>
  
  <div class="dashboard_title">
    <h3 *ngIf="existPending()">Você tem
      <b *ngIf="!isCountLoading">{{ totalItems }}</b>
      <i *ngIf="isCountLoading" class="fa fa-spinner fa-spin"></i>
      {{ getTextPendingTasks(totalItems) }}
    </h3>
  </div>

  <app-dashboard-filter 
    [searchParams]="searchParams"
    (search)="doSearch()">
  </app-dashboard-filter>

  <div class="dashboard_cars">
    <div *ngIf="existPending() else noContent">
      <app-dash-summary
        *ngFor="let item of processes"
        [process]=item
        (onRunningTask)="onRunningTask()"
        (onUpdatedItem)="updateList()"
        (onShowModalPrint)="toggleModalPrint($event)">
      </app-dash-summary>
    </div>

    <ng-template #noContent>
      <p class="no-projects">
        <i class="fa fa-trophy"></i>
        Você não tem tarefas pendentes.
      </p>
    </ng-template>
  </div>


  <div class="pagination-container">
    <div *ngIf="totalPage > 1" class="pagination-pages" role="group" aria-label="...">
      <button *ngIf="currentPage > 20" type="button" class="pagination-item" (click)="firstPages()">«</button>
      <button *ngIf="currentPage > 20" type="button" class="pagination-item" (click)="previousPages()">‹</button>
  
      <button *ngFor="let pageNumber of obterPaginas()" 
              type="button" 
              class="pagination-item" 
              (click)="mudarPagina(pageNumber)" 
              [class.pagination-item--active]="isActive(pageNumber)">
        {{ pageNumber }}
      </button>
  
      <button *ngIf="currentPage < totalPage - 20" type="button" class="pagination-item" (click)="nextPages()">›</button>
      <button *ngIf="currentPage < totalPage - 20" type="button" class="pagination-item" (click)="lastPages()">»</button>
    </div>
  </div>  
</div>

<ng-template #version1>
  <div class="dashboard__list card">
    <p class="card-title">Seus protocolos pendentes</p>

    <p style="text-align: right;">
      {{ (pagingModel?.pageNumber * pagingModel?.pageSize) - pagingModel?.pageSize + 1 }} - {{ pagingModel?.pageNumber * pagingModel?.pageSize }} de
      <b *ngIf="!isCountLoading">{{ totalItems }}</b>
      <i *ngIf="isCountLoading" class="fa fa-spinner fa-spin"></i>
    </p>

    <div class="process_list">
      <div class="process-item process-item_head">
        <div class="process-item__row">
          <p>Nome</p>
        </div>
        <div class="process-item__row">
          <p>Tipo</p>
        </div>
        <div class="process-item__row">
          <p>Status</p>
        </div>
        <div class="process-item__row"></div>
      </div>

      <div *ngIf="existPending() else noContent">
        <app-dash-summary
          *ngFor="let item of processes"
          [process]=item
          (onRunningTask)="onRunningTask()"
          (onUpdatedItem)="updateList()"
          (onShowModalPrint)="toggleModalPrint($event)">
        </app-dash-summary>
      </div>
      <ng-template #noContent>
        <p class="no-projects">
          <i class="fa fa-trophy"></i>
          Não existem processos com tarefas pendentes.
        </p>
      </ng-template>
    </div>


    <div class="pagination-container">
      <div *ngIf="totalPage > 1" class="pagination-pages" role="group" aria-label="...">
        <button *ngIf="currentPage>=16" type="button" class="pagination-item" (click)="firstPages()" [class.m-btn-pagination--active]="isActive(0)"> &lt; &lt;</button>
        <button *ngIf="currentPage>=16" type="button" class="pagination-item" (click)="previousPages(currentPage)" [class.m-btn-pagination--active]="isActive(0)"> &lt;</button>
        <button *ngFor="let pageNumber of obterPaginas(); let index = index;"
          type="button" 
          class="pagination-item"
          (click)="mudarPagina(pageNumber)"
          [class.pagination-item--active]="isActive(pageNumber)">
          {{pageNumber}}
        </button>
        <button *ngIf="currentPage<(totalPage-15)" type="button" class="pagination-item" (click)="nextPages(currentPage)" [class.m-btn-pagination--active]="isActive(0)">&gt;</button>
        <button *ngIf="currentPage<=(totalPage-15)" type="button" class="pagination-item" (click)="lastPages()" [class.m-btn-pagination--active]="isActive(0)">&gt;&gt;</button>
      </div>
    </div>
  </div>
</ng-template>
  
<!-- Modal Print -->
<div *ngIf="showModalPrint" class="modalPrint"  >
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Selecione os itens para imprimir</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="toggleModalPrint()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body print__container">
        <div *ngFor="let itemAttr of itemsAttr">
          <input type="checkbox"  class="checkbox" value="{{itemAttr.attributes[1].value}}" checked (change)="onValueChange($event)" > {{itemAttr.attributes[2].value}}
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn btn-info " (click)="sendPrint()">Imprimir</button>
      </div>
    </div>
  </div>
</div>